function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 48,
  r: 48,
  fill: "#9DC88D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M47.5825 52.5662C48.3171 52.5662 49.0295 52.8611 49.5526 53.3787C50.0702 53.8962 50.3651 54.6142 50.3651 55.3488C50.3651 56.0834 50.0702 56.7957 49.5526 57.3189C49.035 57.8364 48.3171 58.1314 47.5825 58.1314C46.8479 58.1314 46.13 57.8364 45.6124 57.3189C45.0949 56.7957 44.7999 56.0834 44.7999 55.3488C44.7999 54.6142 45.0949 53.8962 45.6124 53.3787C46.13 52.8611 46.8479 52.5662 47.5825 52.5662ZM47.5825 35.4954C48.8119 35.4954 49.8086 36.4921 49.8086 37.7215V48.0756C49.8086 49.3049 48.8119 50.3017 47.5825 50.3017C46.3532 50.3017 45.3564 49.3049 45.3564 48.0756V37.7215C45.3564 36.4921 46.3532 35.4954 47.5825 35.4954ZM69.1477 47.9999C69.1477 59.6607 59.6607 69.1477 47.9999 69.1477C36.3391 69.1477 26.8521 59.6607 26.8521 47.9999C26.8521 36.3391 36.3391 26.8521 47.9999 26.8521C59.6607 26.8521 69.1477 36.3391 69.1477 47.9999ZM73.5999 47.9999C73.5999 33.8843 62.1155 22.3999 47.9999 22.3999C33.8843 22.3999 22.3999 33.8843 22.3999 47.9999C22.3999 62.1155 33.8843 73.5999 47.9999 73.5999C62.1155 73.5999 73.5999 62.1155 73.5999 47.9999Z",
  fill: "#4D774E"
});

function SvgChartError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartError);
export default __webpack_public_path__ + "static/media/chart-error.7984b886.svg";
export { ForwardRef as ReactComponent };